export default __webpack_public_path__ + "static/media/May the 4th.fa8d612c.png";